$(function(){
	var wrapperEls = $('.form-photos');

	for(var i = 0; i < wrapperEls.length; i++){
		(function(){
			var wrapperEl = $(wrapperEls[i]);
			var itemsEl = wrapperEl.find('.form-photos__items')[0];

			if(itemsEl) {
				new Sortable(itemsEl, {
					animation: 150,
					ghostClass: 'form-photos__item--dragged',
					filter: '.locked',
					onMove: function (evt) {
				    if (evt.related)
				    {
				      return !evt.related.classList.contains('locked');
				    }
				  }
				});
			}
		})();
	}
});